import routes from './routes';

let root = {
  items: []
};

routes.forEach(route => {

  if (!route.hidden) {

    let paths = route.path.split('/').filter(s => s !== "");
    let parent = root;

    for (let i = 0; i < paths.length; i++) {
      const path = paths[i];
      let current = parent.children && parent.children.find((i) => i.id === path);

      if (!current) {
        if (i === paths.length - 1) {
          current = {
            id: path,
            name: route.name,
            url: route.path,
            icon: route.icon
          }
        } else {
          current = {
            id: path
          }
        }
        if (!parent.children) {
          parent.children = [];
        }
        parent.children.push(current);
      } else {
        if (i === paths.length - 1) {
          current.name = route.name;
          current.url = route.path;
          current.icon = route.icon;
        }
      }

      parent = current;
    };

  }
});

export default {
  items: root.children
};
